import { Component, OnInit, Input } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexResponsive,
  ApexXAxis,
  ApexYAxis,
  ApexLegend,
  ApexFill,
  ApexTitleSubtitle,
  ApexNonAxisChartSeries,
} from 'ng-apexcharts';
import { MatDialog } from '@angular/material/dialog';
import { UnlockChapterDialogComponent } from '../../../components/unlock-chapter-dialog/unlock-chapter-dialog.component';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';


export type DonutChartOptions1 = {
  series: any;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  plotOptions: any;
  colors: any;
  legend: any;
  xaxis: any;
  yaxis: any;
  fill: any;
  dataLabels: any;
  tooltip: any;
  stroke: any;
  states: any;
  title: any;
};

@Component({
  selector: 'app-chapter-card',
  templateUrl: './chapter-card.component.html',
  styleUrls: ['./chapter-card.component.css']
})

export class ChapterCardComponent implements OnInit {

  @Input() cardSubject: string;
  @Input() chapterData: any = [];
  @Input() isUserSubcribed:boolean = true;
  public donutchartOptions1: Partial<DonutChartOptions1>;
  donutColor: any;
  isFromLearn:boolean = false;

  constructor(public dialog: MatDialog,private selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.isFromLearn = this.selfLearnService.isFromLearn();
    console.log(this.chapterData);

    if (this.cardSubject == 'Physics') {
      this.donutColor = '#D3641F';
    }
    if (this.cardSubject == 'Chemistry') {
      this.donutColor = '#BE3F54';
    }
    if (this.cardSubject == 'Maths') {
      this.donutColor = '#136884';
    }
    if (this.cardSubject == 'Biology') {
      this.donutColor = '#578A43';
    }
    if (this.cardSubject == 'Zoology') {
      this.donutColor = '#663D29';
    }
    if (this.cardSubject == 'Botany') {
      this.donutColor = '#106446';
    }
    if (this.cardSubject == 'Science') {
      this.donutColor = '#7082D4';
    }
    if (this.cardSubject == 'EVS') {
      this.donutColor = '#64AA7D';
    }
    if (this.cardSubject == 'English') {
      this.donutColor = '#C67AEB';
    }
    if (this.cardSubject == 'Hindi') {
      this.donutColor = '#E5AE7C';
    }
    if (this.cardSubject == 'Computer Science') {
      this.donutColor = '#7BB4CA';
    }
    if (this.cardSubject == 'Social Studies') {
      this.donutColor = '#C16634';
    }
    if (this.cardSubject == 'Civics') {
      this.donutColor = '#F7875D';
    }
    if (this.cardSubject == 'Geography') {
      this.donutColor = '#BACC77';
    }
    if (this.cardSubject == 'History') {
      this.donutColor = '#AA8171';
    }
    if (this.cardSubject == 'Logical Reasoning') {
      this.donutColor = '#EB749D';
    }
    if (this.cardSubject == 'General Test') {
      this.donutColor = '#AA4995';
    }
    if (this.cardSubject == 'Statistics') {
      this.donutColor = '#0B2F69';
    }
    if (this.cardSubject == 'Accountancy') {
      this.donutColor = '#16888A';
    }
    if (this.cardSubject == 'Economics') {
      this.donutColor = '#327DD4';
    }
    if (this.cardSubject == 'Business Studies') {
      this.donutColor = '#6193D9';
    }
    if (this.cardSubject == 'Commerce') {
      this.donutColor = '#1EC686';
    }
    if (this.cardSubject == 'Vedic Maths') {
      this.donutColor = '#2584E7';
    }
    if (this.cardSubject == 'Vedic Mathematics') {
      this.donutColor = '#2584E7';
    }
    if (this.cardSubject == 'Problem Solving') {
      this.donutColor = '#AC9595';
    }
    if (this.cardSubject == 'Critical Thinking') {
      this.donutColor = '#60C3D0';
    }

    // donut chart
    this.donutchartOptions1 = {
      series: [this.chapterData?.chapterProgress == 0 ? null : (this.chapterData?.chapterProgress == undefined) ? null : this.chapterData?.chapterProgress],
      chart: {
        height: 100,
        width: 67,
        type: 'radialBar',
        background: 'transparent',
        offsetX: -1,
        offsetY: 1,
      },
      plotOptions: {
        radialBar: {
          inverseOrder: false,
          startAngle: 0,
          endAngle: 360,
          offsetX: 0, // Move chart sides
          offsetY: 0, // Move chart top, bottom
          hollow: {
            margin: 0,
            size: '72%',
            background: 'transparent',
            position: 'front'
          },
          track: {
            show: true,
            startAngle: undefined,
            endAngle: undefined,
            background: 'transparent',
            strokeWidth: '100%',
            opacity: 1,
            margin: 0,
          },
          dataLabels: {
            show: false,
            name: {
              show: false,
              fontSize: '14px',
              fontFamily: undefined,
              fontWeight: 600,
              color: '#3076B5',
              offsetY: 20
            },
            value: {
              show: true,
              fontSize: '12px',
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              color: '#1E2A36',
              offsetY: 5,
              formatter: function (val) {
                return val + '%';
              }
            }
          },
        },
      },
      labels: ["Total"],
      fill: {
        colors: [this.donutColor]
      },
      stroke: {
        lineCap: 'round'
      },
    };



  }


  openChapterUnlockDialog() {
    this.dialog.open(UnlockChapterDialogComponent, { width: '375px', panelClass: 'SLV2-unlock-chapter-modal' });
  }

}
